export const createRuleModal = 'createRuleModal';
